import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface WandIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const WandIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick,
}: WandIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <rect 
                x="4.22136" 
                y="7.05208" 
                width="4" 
                height="18" 
                rx="1" 
                transform="rotate(-45 4.22136 7.05208)" 
                stroke={color} 
                strokeWidth={2}
            />
            <line 
                x1="7.05005" 
                y1="9.87883" 
                x2="9.87848" 
                y2="7.0504" 
                stroke={color} 
                strokeWidth={2}
            />
            <path 
                d="M4 13V15M5 14H3" 
                stroke={color} 
                strokeWidth={2} 
                strokeLinecap="round"
            />
            <path 
                d="M7 17V21M9 19H5" 
                stroke={color} 
                strokeWidth={2} 
                strokeLinecap="round"
            />
            <path 
                d="M14 3V7M16 5H12" 
                stroke={color} 
                strokeWidth={2} 
                strokeLinecap="round"
            />
        </svg>
    )
}

export default WandIcon
